import axios from "axios";
import { toastr } from "react-redux-toastr";

import { openModal } from "./modalAction";

import { FETCH_AWARD, SEARCH_AWARDS, FETCHING_AWARDS } from "./types";

//search  Awards

export const searchAwards = () => async (dispatch) => {
  try {
    const res = await axios.post("/api/AwardSearch");

    dispatch({ type: SEARCH_AWARDS, payload: res.data });
    dispatch({ type: FETCHING_AWARDS, payload: false });
    // dispatch(closeModal());
  } catch (error) {
    console.log("error_searchAward", error);
    if (error && error.response && error.response.status == 401) {
      dispatch(openModal("LoginModal"));
      toastr.error(`${JSON.stringify(error.response.data)}`);
    } else if (error) {
      toastr.error(
        "Oops",
        "Something went wrong.Please Try Again__searchAward"
      );
    }
  }
};

//fetch single Award
export const fetchAward = (id) => async (dispatch) => {
  try {
    const res = await axios.get(`/api/AwardDetail/${id}`);

    dispatch({ type: FETCH_AWARD, payload: res.data });
  } catch (error) {
    if (error && error.response && error.response.status == 401) {
      dispatch(openModal("LoginModal"));
      toastr.error(`${JSON.stringify(error.response.data)}`);
    } else if (error) {
      toastr.error("Oops", "Something went wrong.Please Try Again");
    }
  }
};

// create Award
export const createAward = (values) => async (dispatch) => {
  try {
    const res = await axios.post("/api/AwardCreate", {
      values,
    });

    if (res.data.msg === "success") {
      toastr.success("Award Created");
    }
  } catch (error) {
    if (error && error.response && error.response.status == 401) {
      dispatch(openModal("LoginModal"));
      toastr.error(`${JSON.stringify(error.response.data)}`);
    } else if (error) {
      toastr.error("Oops", "Something went wrong.Please Try Again");
    }
  }
};

//reset Award
export const resetAward = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_AWARD, payload: null });
  } catch (error) {
    toastr.error("Oops", "Something went wrong.Please Try Again");
  }
};
